import { ICollectionMapper } from '../Firestore/ICollectionMapper'
import { IUser, User } from './User'

export class UserMapper implements ICollectionMapper<User> {
  map(data: IUser): User {
    const user = new User(data.id, data.companyId, data.phoneNumber)
    user.apiKey = data.apiKey
    user.tz = data.tz
    user.email = data.email
    user.name = data.name
    user.status = data.status
    user.phoneNumber = data.phoneNumber
    user.admin = data.admin

    return user
  }

  serialize(object: User): IUser {
    delete object.companyRoles
    return JSON.parse(JSON.stringify(object))
  }
}
